"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _themeUi = require("theme-ui");

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var IconCircle = function IconCircle(props) {
  return (0, _themeUi.jsx)("svg", props, (0, _themeUi.jsx)("path", {
    d: "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"
  }));
};

IconCircle.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
};

var Dot = function Dot(_ref) {
  var size = _ref.size,
      animationDelay = _ref.animationDelay,
      props = _objectWithoutPropertiesLoose(_ref, ["size", "animationDelay"]);

  return (0, _themeUi.jsx)(_Icon["default"], _extends({}, props, {
    icon: IconCircle,
    size: size,
    sx: {
      borderRadius: '100%',
      flexShrink: 0,
      flexGrow: 0,
      color: 'inherit',
      '@keyframes bouncedelay': {
        '0%, 80%, 100%': {
          transform: 'scale(0)'
        },
        '40%': {
          transform: 'scale(1.0)'
        }
      },
      animation: "bouncedelay 1400ms infinite ease-in-out both",
      animationDelay: animationDelay + "ms"
    }
  }));
};

Dot.propTypes = {
  animationDelay: _propTypes["default"].number,
  size: _propTypes["default"].number
};

var LoaderDots = function LoaderDots(_ref2) {
  var size = _ref2.size,
      animationDelay = _ref2.animationDelay,
      props = _objectWithoutPropertiesLoose(_ref2, ["size", "animationDelay"]);

  return (0, _themeUi.jsx)(_themeUi.Flex, _extends({}, props, {
    sx: {
      alignItems: 'center',
      justifyContent: 'center'
    }
  }), (0, _themeUi.jsx)(Dot, {
    animationDelay: animationDelay,
    size: size
  }), (0, _themeUi.jsx)(Dot, {
    animationDelay: animationDelay + 160,
    size: size
  }), (0, _themeUi.jsx)(Dot, {
    animationDelay: animationDelay + 320,
    size: size
  }));
};

LoaderDots.propTypes = {
  animationDelay: _propTypes["default"].number,
  size: _propTypes["default"].number
};
LoaderDots.defaultProps = {
  animationDelay: 0,
  size: 1
};
var _default = LoaderDots;
exports["default"] = _default;